import { useQuery } from '@tanstack/react-query'
import { configAjax } from '../../ajax/ConfigAjax'
import { ErrorResponse } from '../../DTOs/Common/ErrorResponse'

// Note: mirrors the server's own default, and stands in until the fetch lands or if it fails, so the NOD
// Difference column still flags the obvious outliers on a cold or offline start.
const NOD_VARIANCE_THRESHOLD_FALLBACK_HOURS = 0.2

export function useOperationsConfig() {
  const { data } = useQuery({
    queryKey: ['config', 'operations'],
    queryFn: async () => {
      const res = await configAjax.getOperationsConfig()
      if (ErrorResponse.isErrorResponse(res)) return null
      return res
    },
    staleTime: Infinity,
    gcTime: 1000 * 60 * 60 * 24 * 7,
  })

  return {
    nodVarianceThresholdHours:
      data?.nodVarianceThresholdHours ?? NOD_VARIANCE_THRESHOLD_FALLBACK_HOURS,
  }
}
